import React, { useState } from 'react';
import { IconFilter } from '@tabler/icons-react';
import { CREATOR_STATUS_OPTIONS, CREATOR_TYPE_OPTIONS } from '../../../constants/statuses';
import { PENDING_FILTER_LABEL, PENDING_FILTER_VALUE } from '../../../constants/creatorReview';
import { FilterBar, FilterBarSearch, FilterBarFilter } from '../../ui/filter-bar';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../../ui/sheet';
import { Button } from '../../ui/button';

const CreatorFilters = ({
  searchTerm,
  onSearchChange,
  filterStatus,
  onFilterStatusChange,
  filterType,
  onFilterTypeChange,
  sortBy,
  onSortChange,
}) => {
  const [filtersOpen, setFiltersOpen] = useState(false);

  const sortOptions = [
    { value: 'username', label: 'Username (A-Z)' },
    { value: 'followers', label: 'Followers (High to Low)' },
    { value: 'score', label: 'Creator Score (High to Low)' },
    { value: 'lastActivity', label: 'Recently Active' },
    { value: 'revenue', label: 'Revenue (High to Low)' },
    { value: 'impressions', label: 'Impressions (High to Low)' }
  ];

  const statusOptions = [
    { value: PENDING_FILTER_VALUE, label: PENDING_FILTER_LABEL },
    ...CREATOR_STATUS_OPTIONS.map(s => ({
      value: s.value,
      label: s.label
    }))
  ];

  const typeOptions = CREATOR_TYPE_OPTIONS.map(t => ({
    value: t.value,
    label: t.label
  }));

  const hasActiveFilters = (filterStatus && filterStatus !== '__all__' && filterStatus !== 'all') || (filterType && filterType !== '__all__' && filterType !== 'all') || (sortBy && sortBy !== 'username');

  return (
    <>
      {/* Mobile: search + filter button */}
      <div className="sm:hidden flex items-center gap-2 mb-4">
        <FilterBarSearch
          placeholder="Search creators..."
          value={searchTerm}
          onChange={onSearchChange}
          className="flex-1 w-full"
        />
        <Button
          variant="outline"
          size="sm"
          onClick={() => setFiltersOpen(true)}
          className="shrink-0 relative"
        >
          <IconFilter className="h-4 w-4 mr-1.5" />
          Filters
          {hasActiveFilters && (
            <span className="absolute -top-1 -right-1 h-2 w-2 bg-accent" />
          )}
        </Button>
      </div>

      {/* Mobile filter sheet */}
      <Sheet open={filtersOpen} onOpenChange={setFiltersOpen}>
        <SheetContent side="bottom" className="h-auto max-h-[80vh] rounded-t-xl">
          <SheetHeader className="pb-4">
            <SheetTitle>Filters</SheetTitle>
          </SheetHeader>
          <div className="space-y-4 pb-6">
            <div>
              <label className="text-xs font-medium text-text-secondary mb-1.5 block">Status</label>
              <FilterBarFilter
                value={filterStatus}
                onChange={(val) => { onFilterStatusChange(val); }}
                options={statusOptions}
                placeholder="All"
                allValue="all"
                className="w-full"
              />
            </div>
            <div>
              <label className="text-xs font-medium text-text-secondary mb-1.5 block">Type</label>
              <FilterBarFilter
                value={filterType}
                onChange={(val) => { onFilterTypeChange(val); }}
                options={typeOptions}
                placeholder="All"
                allValue="all"
                className="w-full"
              />
            </div>
            <div>
              <label className="text-xs font-medium text-text-secondary mb-1.5 block">Sort By</label>
              <FilterBarFilter
                value={sortBy}
                onChange={(val) => { onSortChange(val); }}
                options={sortOptions}
                placeholder="Username"
                includeAll={false}
                className="w-full"
              />
            </div>
            <Button className="w-full mt-2" onClick={() => setFiltersOpen(false)}>
              Apply Filters
            </Button>
          </div>
        </SheetContent>
      </Sheet>

      {/* Desktop: inline filter bar */}
      <div className="hidden sm:block">
        <FilterBar>
          <FilterBarSearch
            placeholder="Search creators..."
            value={searchTerm}
            onChange={onSearchChange}
          />

          <div className="flex-1" />

          <FilterBarFilter
            label="Status"
            value={filterStatus}
            onChange={onFilterStatusChange}
            options={statusOptions}
            placeholder="All"
            allValue="all"
          />

          <FilterBarFilter
            label="Type"
            value={filterType}
            onChange={onFilterTypeChange}
            options={typeOptions}
            placeholder="All"
            allValue="all"
          />

          <FilterBarFilter
            label="Sort"
            value={sortBy}
            onChange={onSortChange}
            options={sortOptions}
            placeholder="Username"
            includeAll={false}
          />
        </FilterBar>
      </div>
    </>
  );
};

export default CreatorFilters;
